/**
 * Gli stati d'offerta del preventivo, lato web.
 *
 * [sc-48351 / task 7] §2.7. Gemello di
 * `crmstart-api/src/services/quoteDraft.service.js`, come `features.js` e
 * `attivita.js`: le cose che le due parti devono dire uguali stanno allo
 * stesso indirizzo da tutt'e due i lati.
 *
 * **Chi comanda è l'API**: un passaggio che non deve succedere lo rifiuta lei,
 * e la pagina non ha l'ultima parola su niente. La tabella qui serve a una cosa
 * sola, sapere cosa mettere nella tendina prima del clic: senza, la pagina
 * dovrebbe chiedere al server cosa si può fare su ognuna delle righe
 * dell'elenco.
 */

export const STATI_OFFERTA = Object.freeze({
  BOZZA: "Bozza",
  PRONTO: "Pronto per invio",
  INVIATO: "Inviato",
  ACCETTATO: "Accettato",
  RIFIUTATO: "Rifiutato",
});

/** Da dove si può andare dove. Vedi il gemello per il perché di ognuno. */
export const PASSAGGI = Object.freeze({
  [STATI_OFFERTA.BOZZA]: [STATI_OFFERTA.PRONTO, STATI_OFFERTA.INVIATO],
  [STATI_OFFERTA.PRONTO]: [STATI_OFFERTA.BOZZA, STATI_OFFERTA.INVIATO],
  [STATI_OFFERTA.INVIATO]: [STATI_OFFERTA.ACCETTATO, STATI_OFFERTA.RIFIUTATO],
  [STATI_OFFERTA.ACCETTATO]: [],
  [STATI_OFFERTA.RIFIUTATO]: [STATI_OFFERTA.BOZZA],
});

/**
 * Il pallino accanto a ogni stato: il viaggio si legge dal colore prima che
 * dalla parola. Grigio finché è in casa, ambra quando è pronto, blu quando è
 * partito, e i due esiti con i colori che hanno già in tutta l'app.
 */
export const COLORI = Object.freeze({
  [STATI_OFFERTA.BOZZA]: "#9ca3af",
  [STATI_OFFERTA.PRONTO]: "#ffa726",
  [STATI_OFFERTA.INVIATO]: "#2a78d6",
  [STATI_OFFERTA.ACCETTATO]: "#4caf50",
  [STATI_OFFERTA.RIFIUTATO]: "#e53935",
});

/** Quando un preventivo non ha ancora un flusso. */
export const SENZA_STATO = "Senza stato";

export function passaggiDa(stato) {
  return PASSAGGI[stato] ?? [];
}

/**
 * Un preventivo senza stato non è una bozza: è nato prima della funzione, o in
 * START. Per quelli il primo passaggio è libero, come lo è nell'API.
 */
export function passaggiPossibili(stato) {
  if (!stato) return [STATI_OFFERTA.BOZZA, STATI_OFFERTA.PRONTO];
  return passaggiDa(stato);
}

/**
 * Le voci della tendina: dove si è adesso, spenta, e dove si può andare.
 *
 * Lo stato di adesso resta in elenco anche se non ci si può tornare: una
 * tendina che non mostra il valore scelto fa sembrare vuoto un campo pieno.
 */
export function opzioniPer(stato) {
  const corrente = {
    value: stato ?? null,
    label: stato || SENZA_STATO,
    color: COLORI[stato] || "#d1d5db",
    disabled: true,
  };
  return [
    corrente,
    ...passaggiPossibili(stato).map((s) => ({
      value: s,
      label: s,
      color: COLORI[s],
    })),
  ];
}
